require('./cart-gift-form.scss');
var BaseViews = require('../../base');

var CartGiftForm = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-gift-form',
    template: require('./cart-gift-form.html'),
    ui: {
        nameInput: '#fmcy-cart-gift-form-name-field',
        alertMessage: '.fmcy-cart-gift-form-alert-message',
        alertMessageText: '.alert-danger'
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                autoFocusPrimaryField: false
            }
        );
    },
    validateVisitedFieldsOnly: false,
    modelEvents: function () {
        var self = this;
        return _.extend(
            {},
            _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
            {
                validated: self.maybeDisplayValidationAlert.bind(self)
            }
        );
    },
    validatedFields: function () {
        var validatedFields = [
            'gift_receiver_name',
            'gift_receiver_email'
        ];
        return validatedFields;
    },
    toggleValidationAlert: function (show) {
        if (show) {
            this.ui.alertMessage.removeClass('hidden');
        } else {
            this.ui.alertMessage.addClass('hidden');
        }
    },
    maybeDisplayValidationAlert: function () {
        /*
        if (this.$el.find('.has-error').length) {
            this.toggleValidationAlert(true);
        } else {
            this.toggleValidationAlert(false);
        }
        */
    },
    onModelAttributeValid: function (attr, selector) {
        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
            this.maybeDisplayValidationAlert();
        }
    },
    onModelAttributeInvalid: function (attr, error, selector, hideAlertMessage) {
        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
            if (!hideAlertMessage) {
              this.maybeDisplayValidationAlert();
            }
        }
    },
    bindings: function () {
        var options = {
            events: ['blur'],
            setOptions: {
                validate: false
            }
        };
        var bindings = {
            '[name=gift_receiver_name]':
                _.extend(
                    {},
                    options,
                    { observe: 'gift_receiver_name' }
                ),
            '[name=gift_receiver_email]':
                _.extend(
                    {},
                    options,
                    { observe: 'gift_receiver_email' }
                ),
            '[name=gift_receiver_message]':
                _.extend(
                    {},
                    options,
                    { observe: 'gift_receiver_message' }
                )
        };

        return bindings;
    },
    events: function () {
        var self = this;

        function setVisited (ev) {
            self._setElementAsVisited($(ev.target));
        }
        return {
            'blur input': setVisited,
            'click select': setVisited
        };
    },
    serializeData: function () {
        return {
            options: this.options
        };
    },
    onRender: function () {
        var self = this;

        if (self.options.autoFocusPrimaryField) {
            setTimeout(function () {
                self.ui.nameInput.trigger('focus');
            }, 0);
        }
        
        if (this.options.error) {
          setTimeout(function () {
              self.model.isValid(self.model.validationFields());
          }, 100);
        }

        BaseViews.LayoutView.prototype.onRender.call(this);
    }
});
module.exports = CartGiftForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-gift-form/cart-gift-form.js
 **/